interface PlayerDebugRecord {
  at: string
  origin: string
  kind: 'object' | 'string' | 'other'
  raw: unknown
}

const RECORD_LIMIT = 500

export default defineNuxtPlugin({
  name: 'app:player-message-debug',

  setup() {
    const config = useRuntimeConfig()

    if (config.public.APP_IS_PROD || !config.public.APP_DEBUG) {
      return
    }

    const records: PlayerDebugRecord[] = []

    const resolveKind = (data: unknown): PlayerDebugRecord['kind'] => {
      if (data && typeof data === 'object') return 'object'
      if (typeof data === 'string') return 'string'
      return 'other'
    }

    const handleMessage = (event: MessageEvent) => {
      const record: PlayerDebugRecord = {
        at: new Date().toISOString(),
        origin: event.origin,
        kind: resolveKind(event.data),
        raw: event.data,
      }

      records.push(record)

      if (records.length > RECORD_LIMIT) {
        records.shift()
      }

      console.info('[player-message]', record.origin, record.kind, record.raw)
    }

    window.addEventListener('message', handleMessage)

    const target = window as unknown as Record<string, unknown>

    target.__pmAll = () => records
    target.__pmDump = () => {
      try {
        return JSON.stringify(records, null, 2)
      } catch {
        return records.map(item => `${item.at} ${item.origin} ${item.kind} ${String(item.raw)}`).join('\n')
      }
    }
    target.__pmClear = () => {
      records.length = 0
    }
    target.__pmOrigins = () => Array.from(new Set(records.map(item => item.origin)))
  },
})
